module.exports = __webpack_public_path__ + "static/media/icon.c5d49bcd.png";